import {useCallback, useRef, useState} from 'react';
import type {UseElementRefReturnObject} from '@Libraries/timeline/types';

export default function useElementRef(): UseElementRefReturnObject {
  const ref = useRef<HTMLElement | null>(null);
  const [width, setWidth] = useState(0);
  const [direction, setDirection] = useState<CanvasDirection>('ltr');

  const resizeObserver = useRef<ResizeObserver>(undefined);

  const setRef = useCallback((element: HTMLElement | null) => {
    if (element !== ref.current) {
      resizeObserver.current?.disconnect();

      if (element) {
        resizeObserver.current = new ResizeObserver((entries) => {
          for (const entry of entries) {
            setWidth(entry.contentRect.width);
          }
        });

        resizeObserver.current.observe(element);

        setDirection(getComputedStyle(element).direction as CanvasDirection);
      }
    }
    ref.current = element;
  }, []);

  return {
    ref,
    setRef,
    width,
    direction,
  };
}
